// extracted by mini-css-extract-plugin
export default {"textareaInput":"FormTextarea_textareaInput__xKFBZ"};